let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("93k58")).then(() => parcelRequire('933Ox'));